import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { APIs } from '../utils/apis';
import Loader from '../sharedComponent/Loader';
import { get, post } from '../utils/httpRequests';
import { message } from 'antd';

const ValidateLogin = props => {
  const { location, history } = props;
  useEffect(() => {
    get({ url: `${APIs.TOKEN_EXCHANGE}${location.search}` }).then(res => {
      if (res.data.meta.status === 200) {
        const { dataList } = res.data.result;
        if (dataList.length > 0) {
          if (!dataList[0].is_staff) {
            message.error('User is not active or is not staff');
            history.push('/login');
          }
          post({ url: `${APIs.LOGIN}`, data: dataList[0] }).then(res => {
            if (res.data.meta.status === 200) {
              window.location.href = '/';
            }
          });
        } else {
          message.error(
            'There is some issue with this service, please contact for customer support.'
          );
          history.push('/login');
        }
      } else {
        message.error(res.data.meta.message);
        history.push('/login');
      }
    });
  }, []);

  return <Loader />;
};

ValidateLogin.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object
};

export default ValidateLogin;
